const PRELOAD_RETRIES_KEY = 'preloadRetries';

/** Вызвать один раз в didMount приложения (роутера например) */
export const resetPreloadRetries = () => localStorage.setItem(PRELOAD_RETRIES_KEY, '0');
const incrementRetry = (attempt: number) => localStorage.setItem(PRELOAD_RETRIES_KEY, `${attempt}`);

/** Вызвать один раз в main.tsx вне компонентов */
export function addVitePreloadErrorHandler() {
  const preloadRetries = parseInt(localStorage.getItem(PRELOAD_RETRIES_KEY) || '0') || 0;

  window.addEventListener('vite:preloadError', () => {
    if (preloadRetries > 5) {
      throw new Error('Component dynamic import error, please reload the page manually');
    }
    incrementRetry(preloadRetries + 1);
    location.reload();
  });
}
